import { Component, input, model, ModelSignal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormValueControl } from '@angular/forms/signals';
import { MatRadioModule } from '@angular/material/radio';

@Component({
    selector: 'baas-boolean-list',
    templateUrl: './baas-boolean-list.html',
    imports: [FormsModule, MatRadioModule, ReactiveFormsModule]
})
export class BaasBooleanList implements FormValueControl<boolean | undefined | null> {
    /** Whether also undefined state (true by default) */
    readonly tristate = input(true);
    readonly trueLabel = input('Ja');
    readonly falseLabel = input('Neen');
    readonly undefinedLabel = input('Onbepaald');
    // NOTE typing needed for d.ts generation, otherwise it becomes of type boolean
    readonly value: ModelSignal<boolean | undefined | null> = model<boolean | undefined | null>(undefined);
}
